<template>
  <section id="projekte" :class="{ 'notLogged': !loggedIn}">
    <div id="pageContent">
      <h1>Projekte</h1>
      <template v-if="noconfigurations">
        <section class="nothing">
          <p>Erstellen Sie Ihr erstes Projekt und finden Sie heraus, wie günstig Web-Entwicklung sein kann.</p>
        </section>
      </template>
      <template v-else>
        <template v-if="loggedIn">
          <hint :condition="!currentUser.verified">Bevor Sie weitere Einstellungen vornehmen können, müssen Sie Ihre E-Mail-Adresse bestätigen. Sehen Sie bitte auch in Ihrem Spam-Ordner nach.</hint>
        </template>
        <aside v-if="configurations.length > 1" id="project-filter">
          <p>Sortieren nach:</p>
          <template v-if="hasSeveralStates">
            <button v-if="sortBy === 'lowestStatusFirst'" @click="setSortBy('highestStatusFirst')" class="backend-button">Projektstatus</button>
            <button v-else @click="setSortBy('lowestStatusFirst')" class="backend-button">Projektstatus</button>
          </template>
          <button v-if="sortBy === 'oldestFirst'" @click="setSortBy('newestFirst')" class="backend-button">Datum</button>
          <button v-else @click="setSortBy('oldestFirst')" class="backend-button">Datum</button>
        </aside>
        <section id="all-projects">
          <single-project v-for="configuration in configurations" :key="configuration.id" :configuration="configuration" :parent-toggle="openToggle" :verified="currentUser.verified" :uid="currentUser.uid" />
        </section>
      </template>
    </div>
    <footer id="projekte-footer">
      <p>Alle Angaben ohne Gewähr. Verbindliche Angaben entnehmen Sie bitte den Angeboten und Auftragsbestätigungen.</p>
    </footer>
    <how-to />
    <made />
    <transition name="fade" mode="out-in">
      <login-modal v-if="!loggedIn"></login-modal>
    </transition>
  </section>
</template>

<script>
import LoginModal from '@/components/LoginModal.vue'
import Hint from '@/components/Hint.vue'
import SingleProject from '@/components/SingleProject.vue'
import Made from '@/components/Made.vue'
import HowTo from '@/components/HowTo.vue'
export default {
  name: 'Projekte',
  components: {
    SingleProject,
    Hint,
    HowTo,
    Made,
    LoginModal
  },
  data: function () {
    return {
      openToggle: false,
      sortBy: 'newestFirst'
    }
  },
  computed: {
    configsUpdated: function () {
      return this.$root.configsUpdated
    },
    loggedIn: function () {
      return this.$root.loggedIn
    },
    configurations: function () {
      return this.$root.currentUser.configurations
    },
    noconfigurations: function () {
      if (this.configurations.length === 0) {
        return true
      } else {
        return false
      }
    },
    currentUser: function () {
      return this.$root.currentUser
    },
    hasSeveralStates: function () {
      if (this.configurations[0] !== undefined) {
        let status = this.configurations[0].status
        let severalStates = false
        this.configurations.forEach(item => {
          if (item.status !== status) {
            severalStates = true
          }
        })
        return severalStates
      } else {
        return false
      }
    }
  },
  methods: {
    setSortBy: function (sortBy) {
      this.openToggle = !this.openToggle
      this.sortBy = sortBy
      this.sortConfigs()
    },
    sortConfigs: function () {
      if (this.configurations !== undefined && this.configurations.length > 1) {
        switch (this.sortBy) {
          case 'highestStatusFirst':
            this.configurations.sort((a, b) => b.status - a.status)
            break
          case 'lowestStatusFirst':
            this.configurations.sort((a, b) => a.status - b.status)
            break
          case 'newestFirst':
            this.configurations.sort((a, b) => b.creationDate.toDate() - a.creationDate.toDate())
            break
          case 'oldestFirst':
            this.configurations.sort((a, b) => a.creationDate.toDate() - b.creationDate.toDate())
            break
          default:
            break
        }
      }
    },
    globalToggle: function () {
      this.openProject = true
    }
    /*
    updateConfigurationName: function () {
      if (this.configurationChanges.name === '') {
        this.configurationChanges.name = 'Unbenanntes Projekt'
      }
      if (this.loggedIn && this.configurationChanges.id !== '') {
        db.collection('configurations').doc(this.configurationChanges.id).update({
          name: this.configurationChanges.name
        }).then(function () {
          console.log('Document successfully updated!')
        }).catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
        this.configurationChanges.id = ''
        this.configurationChanges.name = ''
      }
    },
    editConfig: function (id) {
      this.configurationChanges.id = id
      this.configurationChanges.name = ''
    },
    */
    /*
    getDateFromTimestamp: function (timestamp) {
      if (timestamp !== null) {
        let fullDate = timestamp.toDate()
        let day = fullDate.getDate().toString()
        if (day.length === 1) {
          day = '0' + day
        }
        let month = fullDate.getMonth().toString()
        if (month.length === 1) {
          month = '0' + month
        }
        let year = fullDate.getFullYear()
        return day + '.' + month + '.' + year
      } else {
        return 'NaN'
      }
    },
    getStatus: function (status) {
      switch (status) {
        case 0:
          return 'Anfrage bei clickzip eingegangen'
        case 1:
          return 'Angebot in Erstellung - nur noch etwas Geduld'
        case 2:
          return 'Überprüfen Sie Ihr Angebot - wir sind für Sie da, wenn Sie fragen haben'
        case 3:
          return 'Projekt gestartet'
        default:
          return 'NaN'
      }
    }
    */
  },
  mounted: function () {
    this.sortConfigs()
  },
  watch: {
    configsUpdated: function () {
      this.sortConfigs()
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/css/variables.scss";
#projekte {
  position: relative;
  padding: 0 0 0 0;
  height: 100%;
}
#pageContent {
  transition-duration: 0.2s;
}
.notLogged #pageContent {
  -webkit-backface-visibility: hidden;
  -webkit-perspective: 1000;
  -webkit-transform: translate3d(0,0,0);
  -webkit-transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000;
  transform: translate3d(0,0,0);
  transform: translateZ(0);
  filter: grayscale(1) blur(2px);
  opacity: 0.15;
}
.backend-button {
  @include backend-button();
  &:hover {
    background: #f9f9f9;
  }
}
h1 {
  font-family: $primaryFont;
  color: $secondaryHeadingColor;
  font-weight: $primaryFontBold;
  font-size: 22px;
  padding: 40px 15px 10px 15px;
}
#projekte {
  #pageContent {
    min-height: 100%;
  }
  .nothing {
    position: absolute;
    padding: 20px 15px;
    top: 50%;
    transform: translateY(-50%);
  }
  #project-filter {
    padding: 0 15px;
    margin: 0 0 20px 0;
    display: flex;
    align-items: center;
    p {
      margin: 0 6px 0 0;
      font-family: $secondaryFont;
      font-size: 16px;
      color: $primaryFontColor;
      font-weight: $secondaryFontNormal;
    }
  }
  #all-projects {
    padding: 0 15px;
    display: flex;
    flex-wrap: wrap;
    .single-project {
      width: 100%;
    }
  }
}
#projekte-footer {
  margin: 40px 15px 40px 15px;
  p {
    font-family: $secondaryFont;
    font-size: 14px;
    color: $secondaryFontColor;
  }
}
@media(min-width:767px) {
  h1 {
    font-size: 32px;
    padding: 40px 40px 20px 40px;
  }
  #projekte {
    .nothing {
      padding: 20px 40px;
    }
    #project-filter {
      padding: 0 40px;
      margin: 0 0 30px 0;
    }
    #all-projects {
      padding: 0 40px;
      .single-project {
      }
    }
  }
  #projekte-footer {
    margin: 60px 40px 60px 40px;
  }
}
/*
button {
  border: none;
  outline: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: #fff;
  background: transparent;
  &:hover {
    cursor: pointer;
  }
}
button.button {
  font-weight: $secondaryFontBold;
  padding: 11px 12px;
  line-height: 1;
  background: #f9f9f9!important;
  border: 1px solid #f9f9f9;
  transition: background-color 0.2s border-color 0.2s;
  &:hover {
    background: #f4f4f4!important;
    border-color: #f4f4f4;
  }
}
.nothing {
  background: #fff;
  border-radius: 12px;
  margin: 0 15px 30px 15px;
  font-family: $secondaryFont;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.06);
  padding: 15px;
  min-height: 280px;
  display: flex;
  align-items: center;
  p {
    margin: 0;
  }
}
.tile {
  background: #fff;
  border-radius: 12px;
  margin: 0 15px 30px 15px;
  font-family: $secondaryFont;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.06);
  overflow: hidden;
  header.heading {
    display: flex;
    align-items: center;
    flex-direction: row;
    background: #fafafa;
    padding: 15px;
    position: relative;
    min-height: 80px;
    h2 {
      font-size: 20px;
      color: $primaryFontColor;
      font-family: $primaryFont;
      font-weight: $primaryFontBold;
      line-height: 1.4;
      padding: 6px 0;
      margin: 0;
    }
    input {
      font-size: 20px;
      color: $primaryFontColor;
      font-family: $primaryFont;
      font-weight: $primaryFontBold;
      line-height: 1.4;
      outline: none;
      border: none;
      padding: 5px 0;
      margin: 0;
      width: auto;
      flex-grow: 1;
      background: #fafafa;
    }
    .button-group {
      position: absolute;
      right: 0;
      display: flex;
      flex-direction: column;
    }
  }
  main {
    padding: 15px;
    display: flex;
    flex-direction: column-reverse;
    .config-date {
      color: #949494;
      margin-left: 0;
    }
    h3 {
      font-family: $secondaryFont;
      font-weight: $secondaryFontBold;
      color: $primaryFontColor;
      font-size: 18px;
    }
    ul {
      margin: 10px 0 0 0;
      padding: 0 0 0 20px;
      li {
        list-style: none;
        position: relative;
        font-size: 16px;
        margin-bottom: 4px;
        color: #777;
      }
      li:before {
        content:'';
        display:inline-block;
        background-position:center center;
        background-repeat:no-repeat;
        margin-right:8px;
        position: absolute;
        top: 6px;
        left: -20px;
        width: 14px;
        height: 14px;
        background-image: url('../assets/img/icons/listCheck.svg');
      }
    }
  }
  footer {
    border-top: 2px solid #F2F2F2;
    padding: 15px;
    p {
      color: #949494;
      margin: 5px 0;
    }
  }
  .edit-button {
    margin: 0 10px;
    width: 13px;
    height: 25px;
    background-image: url('../assets/img/icons/edit.svg');
    background-repeat: no-repeat;
    background-size: 13px 25px;
    background-position: center;
    opacity: 0.6;
    transition: opacity 0.2s;
    &:hover {
      opacity: 1;
    }
  }
}
#projekt-footer {
  margin: 20px 15px 20px 15px;
  p {
    font-family: $secondaryFont;
    font-size: 14px;
    color: $secondaryFontColor;
  }
}
@media(min-width:360px) {
  h1 {
    font-size: 26px;
  }
}
@media(min-width:767px) {
  h1 {
    font-size: 32px;
    padding: 40px 40px 20px 40px;
  }
  button.button {
    padding: 11px 18px;
  }
  .nothing {
    margin: 0 40px 30px 40px;
    padding: 20px 30px;
  }
  .tile {
    margin: 0 40px 30px 40px;
    header.heading {
      padding: 20px 30px;
    }
    main {
      padding: 20px 30px;
      flex-direction: row;
      .config-date {
        margin-left: auto;
      }
      .desc {
        color: #606060;
        padding: 0 12px 0 0;
        font-weight: $secondaryFontBold;
      }
    }
    footer {
      padding: 20px 30px;
    }
  }
  #projekt-footer {
    margin: 60px 40px 60px 40px;
  }
}
*/
.fade-enter-active,
.fade-leave-active {
  position: relative;
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>
